<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import queryString from "query-string";
import axios from "axios";
import moment from "moment";

export default {
  name: "App",
  mounted() {
    var vm = this;
    vm.queryinit();
    vm.init();
  },
  methods: {
    init() {
      var vm = this;
      return new Promise(async (resolve) => {
        // const liffid = "1656444257-3ZbroOdk"; //localhost
        const liffid = "1656444257-jdd4nZYB"; // lamy.zwiz.ai
        // const liffid = "1656444257-EoZrRv3Y"; // Develop

        if (this.query.apptype == "line") {
          await this.initializeLiff(liffid);
          this.$store.state.userid = this.query.user;
          this.$store.state.pageid = this.query.pageid;
          vm.getMemberData();
          resolve();
        } else {
          this.$store.state.userid = this.query.userid;
          window.extAsyncInit = function() {
            // the Messenger Extensions JS SDK is done loading
          };
          resolve();
        }
      });
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile();
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        console.error(error);
      }
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
    getMemberData() {
      var vm = this;
      return new Promise((resolve) => {
        var data = {
          userid: vm.$store.state.userid,
          pageid: vm.$route.query.pageid,
          liffuserid: this.$store.state.profile.userId,
        };

        axios
          .get(vm.serverUrl + "lamy/member", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              var memberData = response.data.data[0];
              memberData.totalPurchase = response.data.all_total_purchase;

              vm.$store.commit("setMemberData", memberData);
              await vm.checkMemberExpired();
            } else if (response.data.responsecode == 204) {
              if (this.$route.path !== "/home") {
                this.$router
                  .push({
                    path: "home",
                    query: { ...this.$route.query, v: 1 },
                  })
                  .catch({});
              }
            } else {
              await vm.$swal.fire({
                text: response.data.reason,
                confirmButtonColor: "#000",
              });
              vm.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    async checkMemberExpired() {
      return new Promise((resolve) => {
        var data = {
          member_id: this.$store.state.member.id,
        };

        axios
          .get(this.serverUrl + "lamy/checkMemberExpired", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              if (this.$route.query.page) {
                var page = this.$route.query.page;
                const query = this.$route.query;
                delete query.page;

                this.$router
                  .push({
                    path: page,
                    query: { ...query },
                  })
                  .catch({});
              } else {
                if (
                  this.$route.path !== "/profile" &&
                  this.$route.path !== "/accumulate" &&
                  this.$route.path !== "/benefits"
                ) {
                  this.$router
                    .push({
                      path: "profile",
                      query: { ...this.$route.query, v: 1 },
                    })
                    .catch({});
                }
              }
            } else if (response.data.responsecode == 204) {
              // this.$router.push('/member-expired');
              if (this.$route.path !== "/member-expired") {
                this.$router
                  .push({
                    path: "member-expired",
                    query: { ...this.$route.query },
                  })
                  .catch({});
              }
            } else {
              await this.$swal.fire({
                text: response.data.reason,
                confirmButtonColor: "#000",
              });
              this.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    moment() {
      return moment;
    },
  },
};
</script>
<style lang="scss">
html {
  height: 100%;
}
.rsu {
  font-family: "rsu", sans-serif !important;
  font-size: 1.15rem;
}
.Montserrat {
  font-family: "Montserrat", sans-serif !important;
}
.Kanit {
  font-family: "Kanit", sans-serif !important;
}
.swal2-modal {
  font-family: "Montserrat", "Kanit", sans-serif !important;
}

// .bg-home {
//   background-image: url("./assets/images/bg-home-header.jpg"),url("./assets/images/bg-home-footer.jpg");
//   background-size: contain,contain;
//   background-position: top -100px left 0,top -90px left;
//   background-repeat: no-repeat,no-repeat;
// }

.bg-home {
  background-image: url("./assets/images/bg-home-full.jpg");
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
}
.wrapper-content-box {
  padding: 0 16px;
}
.wrapper-content-box-header-fixed {
  height: 100vh;
  padding-top: 170px;
  padding-bottom: 50px;
  padding-left: 16px;
  padding-right: 16px;

  .content-box {
    overflow-y: auto;
  }
}
.content-box {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 16px;
  font-size: 16px;
}
.bg-subpage {
  background-image: url("./assets/images/bg-howto.jpg");
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
}
.bg-subpage-gray {
  background-image: url("./assets/images/bg-subpage-1.jpg");
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;
}
.bg-subpage-black {
  background-image: url("./assets/images/bg-subpage-2.jpg");
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;
}
.bg-subpage-black1 {
  background-image: url("./assets/images/bg-subpage-3.jpg");
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;
}
.bg-subpage-black2 {
  background-image: url("./assets/images/bg-subpage-4.jpg");
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;
}
</style>
